import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Alert, AlertDescription } from "@/components/ui/alert";
import type { TokenFormProps } from "./types";

export const TokenForm = ({ onSubmit, isLoading, error }: TokenFormProps) => {
  const [token, setToken] = useState("");

  // Check for pre-filled token from URL
  useEffect(() => {
    const prefilledToken = localStorage.getItem('recovery_token_prefill');
    if (prefilledToken) {
      setToken(prefilledToken);
      localStorage.removeItem('recovery_token_prefill');
      // Auto-submit if we have a pre-filled token
      onSubmit(prefilledToken);
    }
  }, [onSubmit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(token);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <Alert variant="destructive">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <div className="space-y-2">
        <Label htmlFor="token" className="text-white">
          Código de recuperación
        </Label>
        <Input
          id="token"
          type="text"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="Ingresa el código recibido por email"
          required
          className="bg-white/10 border-white/20 text-white placeholder:text-white/50"
        />
      </div>
      <Button
        type="submit"
        className="w-full bg-clubbers-red hover:bg-clubbers-red/90"
        disabled={isLoading}
      >
        {isLoading ? "Validando..." : "Validar código"}
      </Button>
    </form>
  );
};